// DS: MO0.4
// TierPromotionCard the smartest - is aware of business logic and picks which CTA button to show
import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import c from 'classnames';
import TierPromotionCardSemiDumb from '../TierPromotionCardSemiDumb';
import { useTierPromotionCardCtaType } from './useTierPromotionCardCtaType';
import s from './TierPromotionCard.scss';
const TierPromotionCard = (_param)=>{
    var { deviation , onClick , ctaClassname , fakeCTAButton , verticalLayout  } = _param, props = _object_without_properties(_param, [
        "deviation",
        "onClick",
        "ctaClassname",
        "fakeCTAButton",
        "verticalLayout"
    ]);
    const ctaButton = useTierPromotionCardCtaType(deviation);
    if (!deviation.tier) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(TierPromotionCardSemiDumb, _extends({
        deviation: deviation,
        onClick: ()=>onClick && onClick(deviation),
        ctaButton: ctaButton,
        ctaClassname: c(ctaClassname, fakeCTAButton && s['fake-button']),
        verticalLayout: verticalLayout
    }, props));
};
TierPromotionCard.displayName = 'TierPromotionCard';
export default TierPromotionCard;
